export function AuthorIdentifiers({ identifiers }) {
  if (!identifiers) return null;
  return (
    <div className="border-b border-gray-300 p-2 flex flex-col gap-2 my-2 md:w-3/4 w-full mx-auto">
      {Object.entries(identifiers).map(([name, value]) => (
        <div key={name} className="flex flex-row gap-2 justify-center">
          <h3 className="text-sm font-medium capitalize">{name}:</h3>
          <h3 className="text-sm font-normal italic">{value.join(" - ")}</h3>
        </div>
      ))}
    </div>
  );
}
